import type { PageFooterSectionName } from './types/PageFooterData';

export const pageFooterOrderedSectionsMetadata: {
  sectionName: PageFooterSectionName;
  desktopOnly?: true;
}[] = [
  { sectionName: 'idealistDays', desktopOnly: true },
  { sectionName: 'findAJob', desktopOnly: true },
  { sectionName: 'postOnIdealist', desktopOnly: true },
  { sectionName: 'aboutUsNew' },
  { sectionName: 'contactUs' },
];
